import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "quoteright" }
const _hoisted_2 = { class: "quickcart" }
const _hoisted_3 = { class: "sticky-quickcart" }
const _hoisted_4 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "line-item"
}
const _hoisted_5 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "line-item"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "line-item"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "total" }
const _hoisted_15 = { class: "paymentplan" }
const _hoisted_16 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  align: "right",
  valign: "top"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  align: "right",
  valign: "top"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  align: "right",
  valign: "top"
}
const _hoisted_23 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  align: "right",
  valign: "top"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  align: "right",
  valign: "top"
}
const _hoisted_30 = { key: 2 }
const _hoisted_31 = {
  align: "right",
  valign: "top"
}

import { LocalDate, DateTimeFormatter } from "@js-joda/core";
import { Quote } from "@/models/Quote";
import { PaymentOptions } from "@/models/QuoteInsurance";
import {
  calculateQuoteTotal,
  formatAmountWithoutCents,
  formatAmount,
} from "@/utils/Utils";
import { Defaults } from "@/models/Defaults";
import { addNoScroll, removeNoScroll } from "@/utils/NoScroll";
import { inject, onMounted, onBeforeUnmount } from "vue";
import { ref, computed, Ref, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteCart',
  setup(__props) {

const shouldShowMobileCart: Ref<boolean> = ref(false);
const inj = inject("$emitter");
const quote = useQuoteStore();

onMounted(() => {
  window.addEventListener("popstate", onPopState);
  (inj as any).on("show-mobile-cart", () => {
    showMobileCart.value = true;
  });
});
onBeforeUnmount(() => {
  // remove the event listener
  window.removeEventListener("popstate", onPopState);
  (inj as any).off("show-mobile-cart", () => {
    showMobileCart.value = false;
  });
});

const showMobileCart = computed({
  get: () => shouldShowMobileCart.value,
  set: (value: boolean) => {
    shouldShowMobileCart.value = value;
    if (value) {
      addNoScroll();
    } else {
      removeNoScroll();
    }
  },
});

function hideMobileCart() {
  showMobileCart.value = false;
}

const quoteTotal: ComputedRef<number> = computed(() => {
  return calculateQuoteTotal(quote);
});

//Function not used
// function onQuoteChanged(): void {
//   const num = quoteTotal.valueOf();
// }

function formatDate(value: string) {
  if (value) {
    return LocalDate.parse(value).format(
      DateTimeFormatter.ofPattern("M/d/yyyy")
    );
  }
}

const currentDate: ComputedRef<string> = computed(() => {
  return LocalDate.now()
    .plusDays(1)
    .format(DateTimeFormatter.ofPattern("M/d/yyyy"));
});

// function formatAmountWithoutCents(value: number): string {
//   return formatAmountWithoutCents(value);
// }
//TODO export formatAmount in utils helper, pure function
// function formatAmount(value: number): string {
//   const num = Number(value);
//   // Create our number formatter.
//   const formatter = new Intl.NumberFormat("en-US", {
//     style: "currency",
//     currency: "USD",

//     // These options are needed to round to whole numbers if that's what you want.
//     //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
//     //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
//   });

//   return num ? formatter.format(num) : "N/A";
// }

//function not used
// function formatPaymentOption(value: any) {
//   const num = Number(value) as PaymentOptions;
//   switch (num) {
//     case PaymentOptions.Monthly:
//       return "Monthly";
//     case PaymentOptions.Annual:
//       return "Annual";
//     case PaymentOptions.FourPay:
//       return "4 Pay";
//     default:
//       return "Unknown";
//   }
// }

const processingFee: ComputedRef<number> = computed(() => {
  if (quote.personalInsurance.paymentOption == PaymentOptions.None) {
    return 0;
  }
  return quote.personalInsurance.paymentOption == PaymentOptions.Monthly
    ? quote.monthlyProcessingFee
    : quote.processingFee;
});

/**
 * Back or forward button has been clicked on browser.
 */
function onPopState() {
  // Remove no scroll, so when we return to the main window it can scroll
  removeNoScroll();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "viewcart",
      class: _normalizeClass({ show: showMobileCart.value })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (hideMobileCart()))
        }, "X"),
        _createElementVNode("div", _hoisted_3, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "subtitle" }, "Your Quote", -1)),
          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", null, "Policy Length", -1)),
                _createElementVNode("td", null, _toDisplayString(_unref(quote).info.policyLength) + " Year", 1)
              ])
            ])
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
          _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Renters Insurance", -1)),
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Coverage Start", -1)),
                _createElementVNode("td", null, _toDisplayString(formatDate(_unref(quote).info.coverageStartDate)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("td", null, "Your liability", -1)),
                _createElementVNode("td", null, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .liabilityAmount
                    )), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "Personal Property Coverage", -1)),
                _createElementVNode("td", null, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .personalPropertyAmount
                    )), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, "Deductible", -1)),
                _createElementVNode("td", null, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails.deductible
                    )), 1)
              ]),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.hurricaneDeductible !== null)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                    _cache[6] || (_cache[6] = _createElementVNode("td", null, "Huricane deductible", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .hurricaneDeductible
                    )), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.replacementCost)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("td", null, "Replacement Cost", -1),
                    _createElementVNode("td", null, "Included", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.waterBackup)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("td", null, "Water Sewer Backup", -1),
                    _createElementVNode("td", null, "Added", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.identityFraud)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("td", null, "Fraud Expense Protection", -1),
                    _createElementVNode("td", null, "Added", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.earthquake)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("td", null, "Earthquake", -1),
                    _createElementVNode("td", null, "Added", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_unref(quote).hasPersonalInsurance && _unref(quote).showAddonOnCart)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Accidental Damage Personal Property Coverage (Add-On)", -1)),
                _createElementVNode("table", _hoisted_12, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("td", null, "Coverage Start", -1)),
                      _createElementVNode("td", null, _toDisplayString(_unref(quote).hasPersonalInsurance ? currentDate.value : "N/A"), 1)
                    ]),
                    (_unref(quote).hasPersonalInsurance)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("td", null, "Include", -1),
                          _createElementVNode("td", null, "✓", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("td", null, "Coverage", -1)),
                      _createElementVNode("td", null, _toDisplayString(_unref(quote).hasPersonalInsurance
                        ? _unref(formatAmountWithoutCents)(
                            _unref(quote).personalInsurance.coverageAmount
                          )
                        : "N/A"), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[14] || (_cache[14] = _createElementVNode("td", null, "Deductible", -1)),
                      _createElementVNode("td", null, _toDisplayString(_unref(quote).hasPersonalInsurance
                        ? _unref(quote).personalInsurance.deductibleAmountText
                        : "N/A"), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _cache[17] || (_cache[17] = _createTextVNode(" Due Today: ", -1)),
            _createElementVNode("b", null, _toDisplayString(_unref(formatAmount)(quoteTotal.value)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[33] || (_cache[33] = _createElementVNode("div", { style: {"text-align":"center"} }, [
          _createElementVNode("strong", null, "Payment Breakdown")
        ], -1)),
        _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
        _cache[35] || (_cache[35] = _createElementVNode("b", null, "Renters Insurance", -1)),
        _createElementVNode("table", _hoisted_16, [
          _createElementVNode("tbody", null, [
            (_unref(quote).rentersInsurance.dueToday)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                  _cache[22] || (_cache[22] = _createElementVNode("td", null, "Payment Due Today:", -1)),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.dueToday)), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(quote).rentersInsurance.paymentOption == 1)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(_unref(quote).rentersInsurance.numberOfPayments - 1) + " monthly installments", 1),
                    _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("em", null, "Includes " + _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.installmentAmount)) + " + " + _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.serviceFee)) + " billing fee ", 1)
                  ]),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(formatAmount)(
                    _unref(quote).rentersInsurance.installmentAmount +
                      _unref(quote).rentersInsurance.serviceFee
                  )), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(quote).rentersInsurance.paymentOption == 3)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(_unref(quote).rentersInsurance.numberOfPayments - 1) + " installments (60 days apart)", 1),
                    _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("em", null, "Includes " + _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.installmentAmount)) + " + " + _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.serviceFee)) + " billing fee ", 1)
                  ]),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(formatAmount)(
                    _unref(quote).rentersInsurance.installmentAmount +
                      _unref(quote).rentersInsurance.serviceFee
                  )), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
        (_unref(quote).hasPersonalInsurance && _unref(quote).showAddonOnCart)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[30] || (_cache[30] = _createElementVNode("hr", null, null, -1)),
              _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
              _cache[32] || (_cache[32] = _createElementVNode("b", null, "Accidental Damage Add-on", -1)),
              _createElementVNode("table", _hoisted_23, [
                _createElementVNode("tbody", null, [
                  (_unref(quote).personalInsurance.paymentOption == 2)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                        _createElementVNode("td", null, [
                          _cache[25] || (_cache[25] = _createTextVNode(" Payment Due Today:", -1)),
                          _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                          (processingFee.value != 0)
                            ? (_openBlock(), _createElementBlock("em", _hoisted_25, [
                                _createTextVNode("Includes " + _toDisplayString(_unref(formatAmount)(_unref(quote).personalInsurance.annualAmount)) + " ", 1),
                                _createElementVNode("span", null, "+ " + _toDisplayString(_unref(formatAmount)(processingFee.value)) + " processing fee", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(formatAmount)(
                      _unref(quote).personalInsurance.annualAmount + processingFee.value
                    )), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(quote).personalInsurance.paymentOption == 1)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                        _createElementVNode("td", null, [
                          _cache[27] || (_cache[27] = _createTextVNode(" Payment Due Today:", -1)),
                          _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                          (processingFee.value != 0)
                            ? (_openBlock(), _createElementBlock("em", _hoisted_28, [
                                _createTextVNode("Includes " + _toDisplayString(_unref(formatAmount)(_unref(quote).personalInsurance.monthlyAmount)) + " ", 1),
                                _createElementVNode("span", null, "+ " + _toDisplayString(_unref(formatAmount)(processingFee.value)) + " processing fee", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(formatAmount)(
                      _unref(quote).personalInsurance.monthlyAmount + processingFee.value
                    )), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(quote).personalInsurance.paymentOption == 1)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                        _cache[29] || (_cache[29] = _createElementVNode("td", null, "11 monthly installments", -1)),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(_unref(formatAmount)(
                      _unref(quote).personalInsurance.monthlyAmount + processingFee.value
                    )), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})